import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID, signal, afterNextRender } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { initFlowbite } from 'flowbite';
import { filter } from 'rxjs/operators';
import { UserDataService } from '../shared/services/userData.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {
  protected readonly title = signal('forms-frontend');
  protected readonly isDashboardRoute = signal(false);

  constructor(
    @Inject(PLATFORM_ID) platformId: object,
    private readonly router: Router,
    private readonly userDataService: UserDataService
  ) {
    if (isPlatformBrowser(platformId)) {
      this.syncBuildingIdFromUrl(this.router.url);
      this.router.events
        .pipe(filter((event) => event instanceof NavigationEnd))
        .subscribe((event) => {
          this.syncBuildingIdFromUrl((event as NavigationEnd).urlAfterRedirects);
        });
    }

    afterNextRender(() => {
      initFlowbite();
    });
  }

  private syncBuildingIdFromUrl(url: string): void {
    this.isDashboardRoute.set(/\/building\/[^/]+\/form-dashboard(?:$|[/?#])/i.test(url));

    const match = url.match(/\/building\/([^/]+)/i);
    const buildingId = match?.[1];
    if (!buildingId) {
      return;
    }

    this.userDataService.setBuildingId(buildingId);
    localStorage.setItem('forms_building_id', buildingId);
  }
}
